import ReactGA from 'react-ga';

export function init(key){
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(key);
  }
}

export function track(category, action, label, value){
  ReactGA.event({
    category,action,label,value
  });
}
